import { IconButton, Stack, Typography } from "@mui/material"
import { ReactComponent as MusicNoteIcon } from 'assets/music-note-croche.svg'
import { ReactComponent as NewIcon } from 'assets/new_icon.svg'
import PopoverMenu from "components/Lego/PopoverMenu/PopoverMenu"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Song } from "src/@types/api-types"
import { useState, MouseEvent } from "react"
import { useDispatch, useSelector } from "react-redux"
import { pushTopToWaitingList, saveCurrentSong, useAddToWaitingList, useLastSongSelector } from "@redux/player"
import { tryToDefineLastSong } from "services/helpers/LastSong"
import { sessionEndTimestampSelector } from "@redux/session/selectors"


interface Props {
    song: Song
}

export const DiscoveryTitleSuggestionItem = ({ song }: Props) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const { addToWaitingList } = useAddToWaitingList();
    const currentLastSong = useLastSongSelector();
    const timeStamp = useSelector(sessionEndTimestampSelector);

    const play = () => {
        dispatch(saveCurrentSong(song));
        closeMenu();
    };
    const playNext = () => {
        dispatch(pushTopToWaitingList(song));

        closeMenu();
    };

    const addToWaitingListFromPopover = () => {
        addToWaitingList([song]);
        closeMenu();
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    const openOption = (e: MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const setAsLastSong = () => {
        tryToDefineLastSong(song, currentLastSong.song, timeStamp, dispatch);
        closeMenu();
    };

    // created at less than 3 monts
    const threeMonth = 1000 * 60 * 60 * 24 * 90;
    const isNew = (new Date().getTime() - new Date(song.createdAt).getTime()) < threeMonth;


    return (
        <Stack direction='row' spacing={2} alignItems={'center'} justifyContent={'space-between'} bgcolor={'#2E2E2E'} p={1} borderRadius={2} width={'100%'} mr={2}>
            <Stack direction={'row'} alignItems={'center'} spacing={1} width={'100%'}>
                {isNew ? <NewIcon /> : <MusicNoteIcon />}
                <Stack direction={'column'} height={40} width={150} overflow={'hidden'}>
                    <Typography
                        fontSize={14}
                        fontWeight="bold"
                        noWrap
                        overflow="hidden"
                        textOverflow="ellipsis"
                    >
                        {song.title}
                    </Typography>
                    <Typography
                        fontSize={12}
                        noWrap
                        overflow="hidden"
                        textOverflow="ellipsis"
                    >
                        {song.artist.name}
                    </Typography>
                </Stack>
            </Stack>
            <IconButton aria-label="more" onClick={openOption} color="inherit" >
                <MoreHorizIcon />
            </IconButton>
            <PopoverMenu
                {...{ play, playNext, closeMenu, anchorEl }}
                addToWaitingList={addToWaitingListFromPopover}
                setAsLastSong={setAsLastSong}
            />
        </Stack>
    )
}